<script>
import PosteAimPicker from '@/components/fiche-aim/fiche-aim/ajustement/poste/PosteAimPicker.vue'

export default {
  name: 'operation-form',
  components: { PosteAimPicker },
  emits: ['input'],
  props: {
    titre: {
      type: String,
      requred: true,
    },
    soustitre: {
      type: String,
      requred: true,
    },
  },
  data() {
    return {
      tempPosteRemboursement: undefined,
      tempMontantRemboursement: undefined,
    }
  },
  computed: {
    estValide() {
      return (
        Number(this.tempPosteRemboursement) !== undefined &&
        this.tempMontantRemboursement !== undefined &&
        !Number.isNaN(this.tempMontantRemboursement) &&
        Number(this.tempMontantRemboursement) > 0
      )
    },
  },
  methods: {
    addRemboursement() {
      this.$emit('input', {
        posteRemboursement: this.tempPosteRemboursement,
        montantRemboursement: this.tempMontantRemboursement,
      })
      this.tempPosteRemboursement = undefined
      this.tempMontantRemboursement = undefined
    },
  },
}
</script>

<template>
  <v-form @submit.prevent="addRemboursement">
    <v-card outlined>
      <v-card-title>{{ titre }}</v-card-title>
      <v-card-subtitle>{{ soustitre }}</v-card-subtitle>
      <v-card-text class="pb-0">
        <poste-aim-picker v-model="tempPosteRemboursement" />
        <v-text-field
          class="pt-4"
          v-model="tempMontantRemboursement"
          dense
          suffix="€"
          clearable
          outlined
          type="number"
          label="Montant"
          hide-spin-buttons
          :rules="[
            (v) => !!v || 'Vous devez renseigner un montant positif',
            (v) => Number(v) > 0 || 'Le montant doit être positif',
          ]"
        />
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer />
        <v-btn type="submit" color="success" :disabled="!estValide"><v-icon>mdi-plus</v-icon>Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
